import axios from "axios";

export default class RaportService {
  constructor() {
    // API URL'sini burada sabit olarak tanımlayın
    //this.apiBaseUrl = "http://127.0.0.1:6999";
    this.apiBaseUrl = "";
  }

  async login(username, password) {
    try {
      const response = await axios.post(`${this.apiBaseUrl}/api/Stellantis/login`, {
        Username: username,
        Password: password
      });
      //console.log(response.data);
      return response;
    } catch (error) {
      console.error("Giriş işlemi sırasında bir hata oluştu:", error);
      throw error;
    }
  }
}
